import { UserAuth } from "@ofqual/portal-core/core/types";
import { UserRole } from "./domain/userRole";
import { Component } from "./presentation/Component";
import { redux } from "./redux";

const hasRole = (usersRoles: number[], rolesToCheck: UserRole[]) =>
  usersRoles.some((usersRole: number) => rolesToCheck.includes(usersRole));

const hasSoC2023ModuleFlag = (user: UserAuth) => {
  return user.experimentalFeatures !== undefined && !!user.experimentalFeatures.find(x => x.moduleName === "portal-soc/2023" && x.toggleType === 1)
}

const hasSoCv2ModuleFlag = (user: UserAuth) => {
  return user.experimentalFeatures !== undefined && !!user.experimentalFeatures.find(x => x.moduleName === "portal-soc/v2" && x.toggleType === 1)
}

  
export const moduleDefinition = {
  component: Component,
  redux,
  visibleOnNavigationBar: (user: any) => hasRole(user.roles, [ 3, 18, 26, 35, 36 ]) 
  && !hasSoC2023ModuleFlag(user)
  && !hasSoCv2ModuleFlag(user)
};